import { ColorOptions, Icon, ModBox, Text } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'

export const ApiError = ({ error, showError }) => {
  if (isEmpty(error) || !showError) {
    return null
  }
  return (
    <ModBox flexDirection={'row'} align={'center'} gap={3} pr={24}>
      <Icon id={'INFO'} color={'#E30513' as ColorOptions} size={16} />
      <Text
        testID={'textInputErrorId'}
        color={'#E30513' as ColorOptions}
        fontFamily={'JioType-Medium'}
        fontSize={12}
        lineHeight={16}
        letterSpacing={-0.06}>
        {error}
      </Text>
    </ModBox>
  )
}
